import { render, staticRenderFns } from "./UploadFDF.vue?vue&type=template&id=da8283c6&scoped=true"
import script from "./UploadFDF.vue?vue&type=script&lang=js"
export * from "./UploadFDF.vue?vue&type=script&lang=js"
import style0 from "./UploadFDF.vue?vue&type=style&index=0&id=da8283c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8283c6",
  null
  
)

export default component.exports